import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Button } from "./ui/button";
import { Baby, Users, Filter, X, Clock } from "lucide-react";

const Chip = ({ active, onClick, icon: Icon, children, testId }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs border transition-colors ${active ? "bg-primary text-primary-foreground border-primary" : "bg-card hover:bg-muted border-border"}`}
    data-testid={testId}
  >
    {Icon && <Icon className="h-3.5 w-3.5" />}{children}
  </button>
);

// Filtros avançados da Igreja Conectada (apenas para quem vê todas as pessoas)
export const ConnectionsFilters = ({ filters, onChange, ministries, count }) => {
  const set = (patch) => onChange({ ...filters, ...patch });
  const limpar = () => onChange({ ministerio_id: "", sexo: "", criancas: false, tutores: false, sem_contato_dias: 0 });

  return (
    <div className="flex flex-wrap items-center gap-2 p-2.5 rounded-xl border bg-muted/20" data-testid="connections-filters">
      <span className="text-xs text-muted-foreground inline-flex items-center gap-1 mr-1"><Filter className="h-3.5 w-3.5" />Filtros</span>

      <Select value={filters.ministerio_id || "all"} onValueChange={(v) => set({ ministerio_id: v === "all" ? "" : v })}>
        <SelectTrigger className="h-8 w-auto min-w-[150px] rounded-full text-xs" data-testid="filter-ministerio">
          <SelectValue placeholder="Ministério" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os ministérios</SelectItem>
          {ministries.map(m => <SelectItem key={m.id} value={m.id}>{m.nome}</SelectItem>)}
        </SelectContent>
      </Select>

      <Select value={filters.sexo || "all"} onValueChange={(v) => set({ sexo: v === "all" ? "" : v })}>
        <SelectTrigger className="h-8 w-auto min-w-[110px] rounded-full text-xs" data-testid="filter-sexo">
          <SelectValue placeholder="Sexo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos</SelectItem>
          <SelectItem value="M">Homens</SelectItem>
          <SelectItem value="F">Mulheres</SelectItem>
        </SelectContent>
      </Select>

      <Chip active={filters.criancas} onClick={() => set({ criancas: !filters.criancas })} icon={Baby} testId="filter-criancas">Crianças</Chip>
      <Chip active={filters.tutores} onClick={() => set({ tutores: !filters.tutores })} icon={Users} testId="filter-tutores">Tutores</Chip>

      <Select value={String(filters.sem_contato_dias || 0)} onValueChange={(v) => set({ sem_contato_dias: Number(v) })}>
        <SelectTrigger className="h-8 w-auto min-w-[150px] rounded-full text-xs" data-testid="filter-sem-contato">
          <Clock className="h-3.5 w-3.5 mr-1 text-muted-foreground" /><SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="0">Qualquer contato</SelectItem>
          <SelectItem value="7">Sem contato há 7+ dias</SelectItem>
          <SelectItem value="15">Sem contato há 15+ dias</SelectItem>
          <SelectItem value="30">Sem contato há 30+ dias</SelectItem>
          <SelectItem value="60">Sem contato há 60+ dias</SelectItem>
        </SelectContent>
      </Select>

      {count > 0 && (
        <Button variant="ghost" size="sm" className="h-8 text-xs gap-1 ml-auto" onClick={limpar} data-testid="filters-clear">
          <X className="h-3.5 w-3.5" />Limpar ({count})
        </Button>
      )}
    </div>
  );
};
